exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-center[data-v-3718d722]{margin:20px auto}.spinner[data-v-3718d722]:after{background:#ff0002!important}a[data-v-3718d722],a[data-v-3718d722]:hover{color:#212529}a.text-categories-red[data-v-3718d722],a.text-categories-red[data-v-3718d722]:hover{color:#ff0004}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3718d722","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/widgets/videos.vue
// module id = +fTL
// module chunks = 0